export enum TRACK_TYPE {
  NORMAL = 'normal',
  RANGE = 'range',
  MULTIPLE_RANGE = 'multipleRange',
}

export const DEFAULT_TRACK_MAX = 100;
export const DEFAULT_TRACK_MIN = 0;
export const DEFAULT_TRACK_STEP = 0;
